// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1bao5","gfeWrapper":"CalendarEvent_gfeWrapper__3mb-a"};